import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import PageHero from "@/components/PageHero";
import { api } from "@/lib/api";
import Seo from "@/components/Seo";

const CATS = ["all", "Weddings", "Corporate Events", "Private Chef", "Appetizers", "Main Courses", "Desserts"];

export default function Gallery() {
  const [images, setImages] = useState([]);
  const [cat, setCat] = useState("all");
  const [lightbox, setLightbox] = useState(null);
  useEffect(() => { api.get("/gallery").then((r) => setImages(r.data)).catch(() => {}); }, []);
  const filtered = cat === "all" ? images : images.filter((i) => i.category === cat);

  return (
    <div data-testid="gallery-page">
      <Seo
        title="Catering Gallery | Weddings, Events & Cuisine — K.O Chef SW Florida"
        description="View photos of weddings, corporate events, private chef plating and gourmet cuisine catered by K.O CHEF & CATERING across Naples, Bonita Springs and Fort Myers, Florida."
        path="/gallery"
      />
      <PageHero overline="Gallery" title="A Feast for the Eyes"
        subtitle="Moments and masterpieces from our kitchens and events."
        image="https://images.unsplash.com/photo-1616671285410-2a676a9a433d?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000" />
      <section className="py-16 md:py-24">
        <div className="container-lux">
          <div className="flex flex-wrap gap-3 justify-center mb-12">
            {CATS.map((c) => (
              <button key={c} onClick={() => setCat(c)} data-testid={`gallery-filter-${c.replace(/\s+/g,"-")}`}
                className={`px-5 py-2 text-xs uppercase tracking-widest border transition-colors ${cat === c ? "bg-gold text-black border-gold" : "border-white/15 text-white/60 hover:border-gold hover:text-gold"}`}>
                {c === "all" ? "All" : c}
              </button>
            ))}
          </div>
          <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 [column-fill:_balance]">
            <AnimatePresence>
              {filtered.map((img, i) => (
                <motion.div key={img.id} layout initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.4, delay: (i % 6) * 0.05 }}
                  className="mb-4 break-inside-avoid cursor-pointer group relative overflow-hidden" onClick={() => setLightbox(img)} data-testid={`gallery-img-${i}`}>
                  <img src={img.url} alt={img.title} className="w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 flex items-end p-5 transition-opacity">
                    <div><p className="text-white text-sm">{img.title}</p><p className="text-gold text-xs uppercase tracking-widest">{img.category}</p></div>
                  </div>
                </motion.div>
              ))}
            </AnimatePresence>
          </div>
        </div>
      </section>
      <AnimatePresence>
        {lightbox && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-6" onClick={() => setLightbox(null)} data-testid="gallery-lightbox">
            <img src={lightbox.url} alt={lightbox.title} className="max-h-[85vh] max-w-full object-contain" />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
